module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic-management-detail"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.items,
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.subject.nama))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "py-0 px-1 ma-0"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "*"
    }
  }, [_c('v-text-field', {
    staticClass: "search_box",
    attrs: {
      "outlined": "",
      "height": "36px",
      "hide-details": "",
      "small": "",
      "dense": "",
      "placeholder": "Ketik kata kunci dan tekan enter"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }, [_c('template', {
    slot: "prepend-inner"
  }, [_c('svg', {
    staticStyle: {
      "margin-top": "10px !important"
    },
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z",
      "fill": "#073554"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z",
      "fill": "#073554"
    }
  })])]), _vm._v(" "), _c('template', {
    slot: "append-outer"
  }, [_c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "plain": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewTopicDialog = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                                    Topik\n                                ")], 1)], 1)], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('v-row', [_vm._l((_vm.filteredCards), function(card) {
    return _c('v-col', {
      key: card.id,
      staticClass: "pa-3",
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "outlined": ""
      }
    }, [_c('v-card-title', [_c('v-list', {
      staticClass: "pa-0 ma-0",
      attrs: {
        "width": "100%"
      }
    }, [_c('v-list-item', {
      staticClass: "pa-0 ma-0"
    }, [_c('v-list-item-content', {
      staticClass: "pa-0 ma-0"
    }, [_c('v-list-item-title', {
      staticClass: "text-subtitle-1 font-weight-bold black--text",
      staticStyle: {
        "word-break": "break-word !important"
      }
    }, [_vm._v("\n                                            " + _vm._s(card.nama) + "\n                                        ")])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "pa-0 ma-0 align-self-start justify-self-end"
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "color": "redLight"
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteConfirmation(card)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(card.kode))]), _vm._v(" "), _c('v-card-actions', [_c('v-col', {
      staticClass: "pa-0 ma-0 d-flex justify-center",
      attrs: {
        "cols": "*"
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "blew",
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(card)
        }
      }
    }, [_vm._v("Ubah Data")])], 1), _vm._v(" "), (!_vm.subTopic && !_vm.$route.query.topic_id) ? _c('v-col', {
      staticClass: "pa-0 ma-0 d-flex justify-center",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "color": "blew",
        "text": "",
        "to": _vm.topic && !_vm.subTopic ?
          {
            path: '/topic-management/detail',
            query: {
              subject_id: _vm.subject.id,
              topic_id: _vm.topic.id,
              sub_topic_id: card.id,
            },
          } :
          {
            path: '/topic-management/detail',
            query: {
              subject_id: _vm.subject.id,
              topic_id: card.id,
            },
          }
      }
    }, [_vm._v("Lihat Sub-Bab")])], 1) : _vm._e(), _vm._v(" "), (!_vm.subTopic && _vm.$route.query.topic_id) ? _c('v-col', {
      staticClass: "pa-0 ma-0 d-flex justify-center",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "color": "blew",
        "text": "",
        "to": _vm.topic && !_vm.subTopic ?
          {
            path: '/topic-management/detail',
            query: {
              subject_id: _vm.subject.id,
              topic_id: _vm.topic.id,
              sub_topic_id: card.id,
            },
          } :
          {
            path: '/topic-management/detail',
            query: {
              subject_id: _vm.subject.id,
              topic_id: card.id,
            },
          }
      }
    }, [_vm._v("Lihat Sub-Sub-Bab")])], 1) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), (!_vm.filteredCards.length) ? _c('v-col', [_c('div', {
    staticClass: "pa-3 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                        Data tidak tersedia\n                    ")])]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showNewTopicDialog = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          attrs: {
            "width": "100%"
          }
        }, [_vm._v("\n                    Tambah Topik Baru\n                ")]), _vm._v(" "), _c('v-card-text', {
          staticClass: "px-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Induk\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "filled": "",
            "outlined": "",
            "disabled": ""
          },
          model: {
            value: (_vm.topicParentName),
            callback: function($$v) {
              _vm.topicParentName = $$v
            },
            expression: "topicParentName"
          }
        })], 1)], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "pa-0"
        }, [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Nama *\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "placeholder": "Nama Topik",
            "outlined": ""
          },
          model: {
            value: (_vm.formTopicName),
            callback: function($$v) {
              _vm.formTopicName = $$v
            },
            expression: "formTopicName"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "dark": "",
            "color": "blew"
          },
          on: {
            "click": function($event) {
              return _vm.addNewTopic()
            }
          }
        }, [_vm._v("Simpan")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showNewTopicDialog),
      callback: function($$v) {
        _vm.showNewTopicDialog = $$v
      },
      expression: "showNewTopicDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          attrs: {
            "width": "100%"
          }
        }, [_vm._v(" Detail Topik ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
          staticClass: "px-0 py-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Induk\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "filled": "",
            "outlined": "",
            "disabled": ""
          },
          model: {
            value: (_vm.selectedTopic.parentName),
            callback: function($$v) {
              _vm.$set(_vm.selectedTopic, "parentName", $$v)
            },
            expression: "selectedTopic.parentName"
          }
        })], 1)], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "pa-0"
        }, [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Kode\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "filled": "",
            "outlined": "",
            "disabled": ""
          },
          model: {
            value: (_vm.selectedTopic.code),
            callback: function($$v) {
              _vm.$set(_vm.selectedTopic, "code", $$v)
            },
            expression: "selectedTopic.code"
          }
        })], 1)], 1), _vm._v(" "), _c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', {
          staticClass: "pa-0"
        }, [_c('v-list-item-title', {
          staticClass: "font-weight-bold pb-2"
        }, [_vm._v("\n                                Nama *\n                            ")]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "placeholder": "Nama Topik",
            "outlined": ""
          },
          model: {
            value: (_vm.selectedTopic.name),
            callback: function($$v) {
              _vm.$set(_vm.selectedTopic, "name", $$v)
            },
            expression: "selectedTopic.name"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "dark": "",
            "color": "blew"
          },
          on: {
            "click": function($event) {
              return _vm.updateTopic()
            }
          }
        }, [_vm._v("Simpan")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), (_vm.showConfirmationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    on: {
      "click:outside": function($event) {
        _vm.showConfirmationModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticStyle: {
            "word-break": "break-word !important"
          }
        }, [_vm._v("\n                    Apakah ada yakin akan menghapus topik\n                    "), _c('strong', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(_vm.selectedTopic.name) + "\n                    ")]), _vm._v("\n                    ?\n                ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "red darken-1",
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("\n                        Cancel\n                    ")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "blew darken-1",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteTopic()
            }
          }
        }, [_vm._v("\n                        Ok\n                    ")])], 1)], 1)]
      }
    }], null, false, 3861080411),
    model: {
      value: (_vm.showConfirmationModal),
      callback: function($$v) {
        _vm.showConfirmationModal = $$v
      },
      expression: "showConfirmationModal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2716df9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/kodifikasi/components/TopicManagementDetail.vue
// module id = 1562
// module chunks = 1